const safeNum = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
};

const extractRows = (candidate) => {
    if (Array.isArray(candidate)) return candidate;
    if (Array.isArray(candidate?.data)) return candidate.data;
    if (Array.isArray(candidate?.rows)) return candidate.rows;
    return null;
};

const hasTrendMetric = (row) => (
    row &&
    typeof row === 'object' &&
    [
        'impressions', 'IMPRESSIONS',
        'clicks', 'CLICKS',
        'conversions', 'CONVERSIONS',
        'cost', 'COST',
        'revenue', 'REVENUE'
    ].some((key) => row[key] != null)
);

const isUsableTrendRows = (rows) => (
    Array.isArray(rows) &&
    rows.some((row) => row && typeof row === 'object' && (row.date || row.x || row.day) && hasTrendMetric(row))
);

export const buildTrendFromStats = (stats) => {
    if (!stats || typeof stats !== 'object') return [];
    const rowsByDate = {};
    const addSeries = (metricKey, series) => {
        if (!Array.isArray(series)) return;
        series.forEach((point) => {
            const date = point?.x ?? point?.date ?? point?.day;
            if (!date) return;
            if (!rowsByDate[date]) rowsByDate[date] = { date };
            const rawValue = point?.y ?? point?.value ?? point?.count ?? 0;
            rowsByDate[date][metricKey] = safeNum(rawValue);
        });
    };

    addSeries('impressions', stats?.impressions?.series);
    addSeries('clicks', stats?.clicks?.series);
    addSeries('conversions', stats?.conversions?.series);
    addSeries('cost', stats?.cost?.series);
    addSeries('revenue', stats?.revenue?.series);

    return Object.values(rowsByDate).sort((a, b) => {
        const aTime = new Date(a.date).getTime();
        const bTime = new Date(b.date).getTime();
        if (Number.isNaN(aTime) || Number.isNaN(bTime)) return 0;
        return aTime - bTime;
    });
};

export const getChannelTrendData = (data, channelKey) => {
    const channel = data?.channel?.[channelKey];
    const candidates = [
        data?.seriesByChannel?.[channelKey],
        data?.trend?.[channelKey],
        data?.trendData?.[channelKey],
        channel?.trend,
        channel?.trendData,
        channel?.timeseries,
        channel?.timeSeries,
        channel?.daily,
        channel?.series,
        channel?.chart
    ];

    for (const candidate of candidates) {
        const rows = extractRows(candidate);
        if (isUsableTrendRows(rows)) return rows;
    }

    return buildTrendFromStats(channel?.stats);
};
